export function getElementById<E extends HTMLElement>(id?: string): E | undefined {
  return (id && (document.getElementById(id) as E)) || undefined;
}
